import styled from 'styled-components';

interface Props {
  size: number;
}

export const TimelineContainer = styled.div`
  width: 100%;
`;

export const LineChartBox = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
  width: 100%;
  scrollbar-gutter: stable; /* Scrollbar space */

  /* WebKit (Chrome, Safari) */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent; /* Hidden look */
    border-radius: 3px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.4); /* Show */
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  &:hover {
    scrollbar-color: rgba(0, 0, 0, 0.4) transparent;
  }
`;

export const LineChart = styled.div<Props>`
  height: 420px;
  min-width: ${({ size }) => `${size * 120}px`};
  margin-bottom: 10px;
`;

export const ComparisonLineChart = styled.div<Props>`
  height: 540px;
  min-width: ${({ size }) => `${size * 120}px`};
  margin-bottom: 10px;
`;
